import { render, staticRenderFns } from "./subsidiary-ledger-table.vue?vue&type=template&id=22e2df64&scoped=true&"
import script from "./subsidiary-ledger-table.vue?vue&type=script&lang=js&"
export * from "./subsidiary-ledger-table.vue?vue&type=script&lang=js&"
import style0 from "./subsidiary-ledger-table.vue?vue&type=style&index=0&id=22e2df64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e2df64",
  null
  
)

export default component.exports